import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const Card = {
	clickToEdit: 'klikni pro psaní...',
	placeholder: 'nový popis...',
	validationText: 'Zbývá {{max}} znaků',
};

export default Object.assign({}, Card, createLabeledMessages(Card));
